import { scoreTone } from "@/lib/api";

const COLORS = { emerald: "#10b981", amber: "#f59e0b", rose: "#f43f5e" };

export const ScoreRing = ({ score = 0, size = 72, testId }) => {
  const r = size / 2 - 6;
  const c = 2 * Math.PI * r;
  const color = score == null ? COLORS[scoreTone(score)] : "var(--brand-accent, #10b981)";
  return (
    <div className="relative shrink-0" style={{ width: size, height: size }} data-testid={testId}>
      <svg width={size} height={size} className="-rotate-90">
        <circle cx={size / 2} cy={size / 2} r={r} stroke="#1e293b" strokeWidth="6" fill="none" />
        <circle cx={size / 2} cy={size / 2} r={r} stroke={color} strokeWidth="6" fill="none" strokeLinecap="round"
          strokeDasharray={c} strokeDashoffset={c - (c * (score || 0)) / 100} style={{ transition: "stroke-dashoffset .8s ease" }} />
      </svg>
      <span className="absolute inset-0 grid place-items-center num font-bold" style={{ fontSize: size / 4, color }}>{score ?? "–"}</span>
    </div>
  );
};

export const VerdictBadge = ({ verdict, testId }) => {
  const cls = verdict === "Go" ? "bg-emerald-500/15 text-emerald-300 border-emerald-500/30"
    : verdict === "No-Go" ? "bg-rose-500/15 text-rose-300 border-rose-500/30" : "bg-amber-500/15 text-amber-300 border-amber-500/30";
  return <span data-testid={testId} className={`text-xs font-semibold uppercase tracking-wider px-2.5 py-1 rounded-full border ${cls}`}>{verdict || "Pending"}</span>;
};
